import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import axios from 'axios';
import { apiHost, config } from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';

const CancelOrder = ({ orderData, fetchOrders, setIsDelete }) => {
  const { id, isQuoteReference, orderId } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, cancelOrderModalText },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancelOrder = () => {
    // request.delete(`/orders/${id}`).then(() => {
    //   setIsDelete({
    //     action: true,
    //     orderId: orderId
    //   });
    //   fetchOrders();
    // });
    axios.put(`${apiHost}/orders/${id}`, {status: 'ORDER_CANCELED'}, config()).then(()=>{
      setIsDelete({
      action: true,
      orderId: orderId
    });
      fetchOrders();
      setIsModalOpen(false);
    });
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{cancelButtonLabel}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText={cancelOrderModalText}
        confirmCTAText={confirmButtonLabel}
        // cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleCancelOrder()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

CancelOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default CancelOrder;
